import request from '../utils/request';
import { parsePropertyToUrl } from '../utils/common';

export const getAuditMeetings = params => {
  return request(
    `/smartmeeting/smart/third/getAuditMeetings?${parsePropertyToUrl(params)}`
  );
};

export const auditMeeting = ({ lang, ...data }) => {
  return request(`/smartmeeting/smart/third/auditMeeting?lang=${lang}`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

/**
 * 获取申请了会议服务的会议信息
 * @param pageNo
 * @param pageSize
 * @returns {Object}
 */
export const getSvcMeetings = ({ pageNo, pageSize }) => {
  return request(
    `/smartmeeting/smart/meetingsvc/getSvcMeetings?pageNo=${pageNo}&pageSize=${pageSize}`,
    {
      method: 'POST',
      body: JSON.stringify({ pageNo, pageSize }),
      headers: { 'Content-Type': 'application/json' }
    }
  );
};

//会议服务审批
export const auditSvc = params => {
  return request(
    `/smartmeeting/smart/meetingsvc/auditSvc?${parsePropertyToUrl(params)}`
  );
};



// WEBPACK FOOTER //
// ./src/services/audit.js